
export function toCamelCase(str: string) {
  str = str.replace(/([A-Z])/g, ' $1');
  str = str.charAt(0).toUpperCase() + str.slice(1);
  return str;
}
